import { Ref, ref, watch } from "vue";

export function useInputChangeFlag(input: Ref<string>) {
  const hasInputBeenUsed = ref<boolean>(false);

  watch(input, () => {
    if (!hasInputBeenUsed.value) {
      hasInputBeenUsed.value = true;
    }
  });

  return {
    hasInputBeenUsed,
  };
}
